import React from "react";
import CountUp from "react-countup";

function Funfact({ funfact: { title, count, icon = null }, isVisible }) {
  const winWidth = window.innerWidth;
  const isItemVisible = isVisible === undefined ? true : isVisible;
  const countQuery = () => {
    if (winWidth && winWidth > 767) {
      return isItemVisible ? <CountUp end={count} /> : 0;
    }
    return <CountUp end={count} />;
  };
  return (
    <div className="fact-item text-center">
      {icon ? <i className={`${icon} icon-circle`}></i> : null}
      <h2 className="count">{countQuery()}</h2>
      <span>{title}</span>
    </div>
  );
}

export default Funfact;
